﻿import { message } from 'ant-design-vue';

const DEDUP_METHODS = ['success', 'error', 'warning', 'info', 'open'] as const;

let isInstalled = false;

type MessageMethod = (typeof DEDUP_METHODS)[number];

function getMessageContent(firstArg: any): string {
  if (typeof firstArg === 'string') {
    return firstArg;
  }

  if (firstArg && typeof firstArg === 'object') {
    const content = firstArg.content;
    return content == null ? '' : String(content);
  }

  return '';
}

function getMessageKey(firstArg: any): string {
  if (firstArg && typeof firstArg === 'object' && firstArg.key != null) {
    return String(firstArg.key);
  }
  return '';
}

export function installGlobalMessageDedupe(windowMs = 1800): void {
  if (isInstalled) {
    return;
  }

  const recentMessages = new Map<string, number>();

  const shouldSuppress = (method: MessageMethod, firstArg: any): boolean => {
    const content = getMessageContent(firstArg);
    if (!content) {
      return false;
    }

    const key = getMessageKey(firstArg);
    const fingerprint = `${method}|${key}|${content}`;
    const now = Date.now();
    const lastShown = recentMessages.get(fingerprint);

    // Best effort cleanup to avoid unbounded map growth.
    if (recentMessages.size > 1000) {
      recentMessages.forEach((time, mapKey) => {
        if (now - time > windowMs * 2) {
          recentMessages.delete(mapKey);
        }
      });
    }

    if (lastShown != null && now - lastShown < windowMs) {
      return true;
    }

    recentMessages.set(fingerprint, now);
    return false;
  };

  DEDUP_METHODS.forEach((method) => {
    const original = (message as any)[method]?.bind(message);
    if (typeof original !== 'function') {
      return;
    }

    (message as any)[method] = (...args: any[]) => {
      if (shouldSuppress(method, args[0])) {
        return () => undefined;
      }

      return original(...args);
    };
  });

  isInstalled = true;
}
